import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
};

const batchCancellationsSlice = createSlice({
  name: 'batchesCancellationUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, resetFilters } = batchCancellationsSlice.actions;
const batchCancellationsReducer = batchCancellationsSlice.reducer;
export default batchCancellationsReducer;